import { PhasrRecommendationSideMenuWebComponent } from './component/PhasrRecommendationSideMenuWebComponent';
import { WEB_COMPONENT_PHASR_RECOMMENDATION_SIDE_MENU } from '../../webcomponents.constants';

export { PhasrRecommendationSideMenuWebComponent };

window.customElements.define(WEB_COMPONENT_PHASR_RECOMMENDATION_SIDE_MENU, PhasrRecommendationSideMenuWebComponent);
